import nodeClient from "./node-client";

export const getMedicineDetails = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/find/product?${encodeURI(query)}`
  );
  return response.data;
};
export const saveMedicine = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/add/product`,
    payload
  );
  return response.data;
};
export const searchCompounds = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/search/generic/view?${encodeURI(query)}`
  );
  return response.data;
};
export const searchGlobalMedicine = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/search/product?${encodeURI(query)}`
  );
  return response?.data;
};
export const searchItemType = async () => {
  const response = await nodeClient.get(`/service/private/v0/list/itemtype`);
  return response.data;
};

export const searchBrands = async (query) => {
  const response = await nodeClient.post(
    `/service/private/v0/list/brand?${encodeURI(query)}`
  );
  return response.data;
};
export const getPharmaProVariables = async () => {
  const response = await nodeClient.get(`/service/private/v0/variables`);
  return response.data;
};

export const searchMedicine = async (query = "") => {
  const response = await nodeClient.get(
    `/service/protected/v0/medicine/view/stocks?${encodeURI(query)}`
  );
  return response?.data?.result;
};
export const computeStock = async (query) => {
  const response = await nodeClient.get(
    `/service/protected/v0/medicine/compute/stock?${encodeURI(query)}`
  );
  return response?.data;
};

export const getProductLogs = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/get/product/log?${encodeURI(query)}`
  );
  return response?.data?.result;
};

export const bulkUpload = async (payload) => {
  const response = await nodeClient.post(
    `/service/protected/v0/product/bulk/update`,
    payload
  );
  return response?.data;
};

export const bulkUpdateMedicines = async (payload) => {
  const response = await nodeClient.post(
    `/service/protected/v0/product/bulk/update/medicines`,
    payload
  );
  return response?.data;
};
